<div class="min-h-[300px] w-full">
    <p-card class="flex flex-column dados-gerais-card">
        <div class="img-container text-center">
            <div class="layout-topbar-logo">
                <img src="images/logos/crms/{{ layoutService.isDarkTheme() || false ? 'branco' : 'cinza' }}/{{ uf().toLowerCase() }}.png" />
            </div>
        </div>
        <div class="px-5 pt-5 relative">
            @if (isLoading()) {
                <div class="loading-overlay">
                    <p-progressSpinner aria-label="A carregar dados" />
                </div>
            }

            <div class="space-y-4" [class.opacity-55]="isLoading()">
                <div class="flex items-center gap-2">
                    <i class="pi pi-id-card cor"></i>
                    <span class="text-900 font-medium"><strong>Dados Gerais</strong></span>
                </div>

                <div class="pl-1 text-900 font-medium leading-7">
                    {{ valorOuTraco(orgao()?.razaoSocial) }}
                </div>

                <div class="pl-1 text-700 leading-6">
                    {{ valorOuTraco(orgao()?.descricao) }}
                </div>

                <div class="space-y-3 pt-2">
                    <div class="grid grid-cols-[7rem_minmax(0,1fr)] gap-x-4 items-start">
                        <span style="color: var(--primary-color)">Sigla:</span>
                        <span class="quebra-valor">{{ valorOuTraco(orgao()?.sigla) }}</span>
                    </div>
                    <div class="grid grid-cols-[7rem_minmax(0,1fr)] gap-x-4 items-start">
                        <span style="color: var(--primary-color)">UF:</span>
                        <span class="quebra-valor">{{ valorOuTraco(orgao()?.uf ?? uf()) }}</span>
                    </div>
                    <div class="grid grid-cols-[7rem_minmax(0,1fr)] gap-x-4 items-start">
                        <span style="color: var(--primary-color)">CNPJ:</span>
                        <span class="quebra-valor">{{ formatarCnpj(orgao()?.registro) }}</span>
                    </div>
                    <div class="grid grid-cols-[7rem_minmax(0,1fr)] gap-x-4 items-start">
                        <span style="color: var(--primary-color)">Presidente:</span>
                        <span class="quebra-valor leading-6">{{ valorOuTraco(orgao()?.presidente) }}</span>
                    </div>
                    <div class="grid grid-cols-[7rem_minmax(0,1fr)] gap-x-4 items-start">
                        <span style="color: var(--primary-color)">Situação:</span>
                        <span class="quebra-valor">{{ valorOuTraco(orgao()?.situacao) }}</span>
                    </div>
                </div>
            </div>

            <div class="pt-6 pb-5">
                <app-estado-select [(uf)]="uf"></app-estado-select>
            </div>
        </div>
        <div class="border-border-light dark:border-border-dark mt-4">
            <div class="bg-blue-100 dark:bg-blue-900/30 border-l-4 border-blue-500 text-blue-700 dark:text-blue-300 p-4" role="alert">
                <p class="font-bold">Atualizado em {{ formatarData(orgao()?.dataAtualizacao) }}</p>
                <p>Por: {{ valorOuTraco(orgao()?.usuario) }}</p>
            </div>
        </div>
    </p-card>
</div>
